import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import TypeEditor from '../../../components/cbt/type/Editor';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import { IGetTestType, IPostTestTypeReq } from '../../../models/testCenter.model';
import { postTestType } from '../../../api/testCenter.api';

const CbtTypeCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios<IGetTestType>();

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.save1'));
      history.push(`/cbt/type?eduStepCode=${submitRes?.data?.eduStepCode}`);
    }
  }, [submitRes]);

  const onSubmit = (req: IPostTestTypeReq) => {
    submitExecute(postTestType(req));
  };

  return (
    <div className="content scrollbar">
      {submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={submitError} />
      <SimpleHeader
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.type.title3')}
        onlyTitle
      />
      <TypeEditor
        type={null}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default CbtTypeCreate;
